import React from 'react';
import { SearchInputProps } from 'evergreen-ui';
import SearchInputByName, { SearchInputByNameProps } from 'Shared/SearchInputByName';

export type StationSearchByNameProps = SearchInputProps & {
  text: string,
  updateText: (searchText: string) => void,
  debounceDelay?: SearchInputByNameProps['debounceDelay'],
}
/** Строка ввода поискового текста для станций, где при updateValue происходит задержка (debounce) */
export function StationSearchByName({ text, updateText, debounceDelay }: StationSearchByNameProps) {
  return (
    <SearchInputByName
      placeholder="Название станции..."
      value={text}
      updateValue={updateText}
      debounceDelay={debounceDelay}
    />
  );
}
export const MemoStationSearchByName = React.memo(StationSearchByName);
MemoStationSearchByName.displayName = 'MemoStationSearchByName';
export default StationSearchByName;
